import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-okr-types",
  "use": "icon-okr-types-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-okr-types\">\n    <rect x=\"5\" y=\"5\" width=\"14\" height=\"14\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"2\" />\n    <path d=\"M8.02734 16L10.9629 7.54492H13.043L15.9844 16H14.1211L12.0586 9.23242H11.9531L9.88477 16H8.02734ZM9.78516 13.9492V12.625H14.1621V13.9492H9.78516Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol